import { Group, Loader, Stack, Text } from '@mantine/core'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { getApiError } from '@/api/helpers/apiError'
import { useGetImportCameras } from '@/queries/cameraQueries'
import { CameraSource, ImportCameraData } from '@/types/camera'
import { Device } from '@/types/device'
import {
  FormValues,
  MilestoneUrlForm
} from '../MilestoneUrlForm/MilestoneUrlForm'

type MilestoneUrlHandlerProps = {
  devices: Device[]
  onCamerasFetched: (deviceId: string, cameras: ImportCameraData[]) => void
}

export const MilestoneUrlHandler = ({
  devices,
  onCamerasFetched
}: MilestoneUrlHandlerProps) => {
  const intl = useIntl()
  const [errorDetails, setErrorDetails] = useState<string | null>(null)
  const { mutateAsync: getCameras, isPending } = useGetImportCameras()

  const handleSubmit = async (values: FormValues) => {
    setErrorDetails(null)

    try {
      const { cameras } = await getCameras({
        deviceId: values.deviceId,
        integrationUrl: values.milestoneUrl,
        source: CameraSource.Milestone
      })

      onCamerasFetched(values.deviceId, cameras)
    } catch (err) {
      const { errorMessage } = getApiError(err)

      const message =
        errorMessage ||
        intl.formatMessage({ id: 'cameras.import.milestone.connection.error' })

      setErrorDetails(message)
    }
  }

  return (
    <Stack gap="xs">
      <MilestoneUrlForm
        devices={devices}
        isLoading={isPending}
        onSubmit={(values) => void handleSubmit(values)}
      />

      {isPending && (
        <Group align="center" wrap="nowrap">
          <Loader size="xs" />

          <Text size="xs">
            <FormattedMessage id="cameras.import.milestone.connection.pending" />
          </Text>
        </Group>
      )}

      {errorDetails && (
        <Text c="red" size="xs">
          {errorDetails}
        </Text>
      )}
    </Stack>
  )
}
